import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext, { PageContextPayload } from '@contexts/pageContext'

import ManagePortalDataDetailedFeaturesModal from '@modals/ManagePortalDataDetailedFeaturesModal'

import PageContent from './components/PageContent'

const defaultState = {
  showManagePortalDataDetailedFeaturesModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManagePortalDataDetailedFeaturesModal: {
      closeModal: () => setState({ showManagePortalDataDetailedFeaturesModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}

const PortalData = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showManagePortalDataDetailedFeaturesModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showManagePortalDataDetailedFeaturesModal: () => {
        setModalData('ManagePortalDataDetailedFeaturesModal', {})
        setState({ showManagePortalDataDetailedFeaturesModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <ManagePortalDataDetailedFeaturesModal
          callbacks={callbacks('ManagePortalDataDetailedFeaturesModal', setState)}
          showModal={showManagePortalDataDetailedFeaturesModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default PortalData
